import axios from 'axios';
import { objectToQuery } from 'common/helpers/filters.helper';
import {
  IPurchaseOrderCollection,
  IPurchaseOrderCollectionParams,
  IPurchaseOrderCreatePayload,
  IPurchaseOrderModel,
  IPurchaseOrderModelParams,
  IPurchaseOrderOutstandingPayablesModel,
  IPurchaseOrderRecoBasisFilters,
  IPurchaseOrderRecoBasisModel,
  IPurchaseOrderRecoModel,
  IPurchaseOrderRecoParams,
  IPurchaseOrderRecoStoreCollection,
  IPurchaseOrderStoreCollection,
} from 'entities/PurchaseOrder/PurchaseOrder.models';

const basePath = '/purchase-orders';

export const purchaseOrderTransport = {
  getCollection: (params: IPurchaseOrderCollectionParams): Promise<IPurchaseOrderCollection> =>
    axios.get(`${basePath}`, { params }),
  getBySonum: (params: IPurchaseOrderModelParams): Promise<IPurchaseOrderModel> =>
    axios.get(`${basePath}/${params.sonum}`),
  create: (payload: IPurchaseOrderCreatePayload): Promise<IPurchaseOrderModel> => axios.post(`${basePath}`, payload),
  getStoreCollection: (): Promise<IPurchaseOrderStoreCollection> => axios.get(`${basePath}/stores`),
  getReco: (params: IPurchaseOrderRecoParams): Promise<IPurchaseOrderRecoModel> =>
    axios.get(`${basePath}/reco`, { params }),
  getRecoBasis: (filters: IPurchaseOrderRecoBasisFilters): Promise<IPurchaseOrderRecoBasisModel> =>
    axios.get(`${basePath}/reco-basis${objectToQuery(filters)}`),
  getOutstandingPayables: (params?: { storeCode?: string }): Promise<IPurchaseOrderOutstandingPayablesModel> =>
    axios.get(`${basePath}/outstanding-payables`, { params }),
  // MBC-85: Track PO RECO column.
  getRecoStoreCollection: (): Promise<IPurchaseOrderRecoStoreCollection> =>
    axios.get(`${basePath}/reco-stores`),
};
